module.exports = __webpack_public_path__ + "img/tuboDrenoAcessorio3.15416376.png";